
const FormsBase = () => import('./components/FormsBase.vue');
const FormsShow = () => import('./components/FormsShow.vue');
const FormEntriesBase = () => import('./components/FormEntriesBase.vue');
const FormEntriesShow = () => import('./components/FormEntriesShow.vue');
const FormEntryEditor = () => import('./components/FormEntryEditor.vue');

export default [
    {
        path: '/forms',
        component: FormsBase,
        meta: {
            title: 'Forms',
            group: 'main',
            icon: 'IconForm',
            app: ['form'],
            perms: [
                'form_entry_create',
                'form_entry_view_all',
                'form_entry_edit',
                'form_entry_delete'
            ]
        },
        children: [
            {
                path: '',
                component: FormsShow,
                name: 'forms-list',
                meta: {
                    title: 'List',
                    group: 'main',
                    exact: true
                }
            },
            {
                path: 'entries',
                component: FormEntriesBase,
                meta: {
                    title: 'Entries',
                    group: 'main',
                },
                children: [
                    {
                        path: '',
                        component: FormEntriesShow,
                        name: 'form-entries-show',
                    },
                    {
                        path: ':form_entry_id',
                        component: FormEntryEditor,
                        name: 'form-entry-edit',
                        props: true,
                        meta: {
                            title: 'Entry',
                        }
                    },
                    {
                        path: ':form_entry_id(\\d+)/sections/:section_id',
                        component: FormEntryEditor,
                        name: 'form-entry-edit-section',
                        props: true
                    },
                ]
            }
        ]
    },
]
